<!-- ImageGallery.vue -->
<template>
    <div>
        <!-- Thumbnails -->
        <div class="thumbnails">
            <div
                v-for="(item, idx) in thumbnails"
                :key="idx"
                class="thumb"
                @click="open(idx)"
            >
                <video
                    v-if="item.type === 'video'"
                    :src="item.url"
                    muted
                    preload="metadata"
                    class="video-thumb"
                    alt="Thumbnail"
                ></video>
                <img v-else :src="item.url" alt="Thumbnail" />
                <div v-if="item.type === 'video'" class="play-icon">▶</div>
                <div v-if="idx === 4 && media.length > 5" class="overlay">
                    +{{ media.length - 5 }} More Items
                </div>
            </div>
        </div>

        <!-- Lightbox Popup -->
        <div v-if="isOpen" class="lightbox" @click.self="close">
            <div class="lightbox-content">
                <button class="close-btn" @click="close">×</button>
                <button class="nav-btn prev" @click="prev">‹</button>
                <template v-if="media[currentIndex].type === 'video'">
                    <video
                        class="lightbox-image"
                        :src="media[currentIndex].url"
                        controls
                        autoplay
                    ></video>
                </template>
                <template v-else>
                    <img
                        :src="media[currentIndex].url"
                        class="lightbox-image"
                        alt="Full view"
                    />
                </template>
                <button class="nav-btn next" @click="next">›</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ImageGallery",
    props: {
        media: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            isOpen: false,
            currentIndex: 0,
            videoPlaceholder: "https://via.placeholder.com/120x120?text=Video",
        };
    },
    computed: {
        // show only the first two thumbnails
        thumbnails() {
            return this.media.slice(0, 5);
        },
    },
    methods: {
        open(idx) {
            this.currentIndex = idx;
            this.isOpen = true;
        },
        close() {
            this.isOpen = false;
        },
        next() {
            this.currentIndex = (this.currentIndex + 1) % this.media.length;
        },
        prev() {
            this.currentIndex =
                (this.currentIndex + this.media.length - 1) % this.media.length;
        },
    },
};
</script>

<style scoped>
.thumbnails {
    display: flex;
    gap: 1rem;
}
.thumb {
    position: relative;
    width: 120px;
    height: 120px;
    border: 1px solid #ccc;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
}
.thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    background-color: rgba(0, 0, 0, 0.6);
    padding: 0.28rem 0.6rem;
    border-radius: 50%;
    z-index: 2;
    pointer-events: none;
}
.video-thumb {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border: none;
    pointer-events: none;
}
.overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 128, 0, 0.8);
    color: white;
    text-align: center;
    padding: 0.4rem 0;
    font-size: 0.9rem;
}

/* Lightbox */
.lightbox {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}
.lightbox-content {
    position: relative;
    max-width: 80%;
    max-height: 80%;
}
.lightbox-image {
    display: block;
    max-width: 100%;
    max-height: 100%;
    margin: 0 auto;
}
.nav-btn,
.close-btn {
    position: absolute;
    background: transparent;
    border: none;
    color: white;
    font-size: 2rem;
    cursor: pointer;
    padding: 0;
    line-height: 1;
    user-select: none;
}
.nav-btn:hover,
.close-btn:hover {
    color: #bbb;
}
.prev {
    top: 50%;
    left: -2rem;
    transform: translateY(-50%);
}
.next {
    top: 50%;
    right: -2rem;
    transform: translateY(-50%);
}
.close-btn {
    top: -2rem;
    right: 0;
}
</style>
